import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/patreon_join.png'
import _imports_1 from '@/assets/donate.png'


const _withScopeId = n => (_pushScopeId("data-v-1b713ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.patreon.com/jortsoft/membership",
  target: "__blank"
}, "პაკეტებს", -1))
const _hoisted_8 = {
  key: 1,
  class: "text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.patreon.com/jortsoft/membership",
  target: "__blank"
}, "packages", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.patreon.com/jortsoft/posts",
  class: "join",
  target: "__blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "200px",
    alt: "Join Button"
  })
], -1))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 0,
  class: "text"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "text"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.donationalerts.com/r/jortsoft666",
  class: "join",
  target: "__blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "200px",
    alt: "Join Button"
  })
], -1))

import { store } from '@/store/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Support',
  setup(__props) {

const Store = store();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(Store).getCurrentLang == 'GE' ? 'შემოდი Patreon-ზე!' : 'Join Patreon'), 1),
      (_unref(Store).getCurrentLang == 'GE')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(" Patreon არის იდეალური გზა, რითაც შეგიძლია მხარი დამიჭირო და თან მიიღო სარგებელი. "),
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" გადახედე ფასიან "),
            _hoisted_7,
            _createTextVNode(" და ისარგებლო ბენეფიტებით. ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _createTextVNode(" Patreon is the perfect way for you to support me and benefit from it. "),
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" review the paid "),
            _hoisted_11,
            _createTextVNode(" and enjoy the benefits. ")
          ])),
      _hoisted_12
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(Store).getCurrentLang == 'GE' ? 'დონაცია' : 'Donation'), 1),
      (_unref(Store).getCurrentLang == 'GE')
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
            _createTextVNode(" თუ უბრალოდ დონაციის გაკეთება გინდა, შეგიძლია დაადონატო რამდენიც გაგიხარდება. "),
            _hoisted_16,
            _hoisted_17,
            _createTextVNode(" შენი სახელი გამოჩნდება ტოპ დოანტორებში სტრიმზე. თანხა მთლიანად მოხმარდება არხის განვითარებას ♥ ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_18, [
            _createTextVNode(" If you just want to donate, you can donate as much as you like. "),
            _hoisted_19,
            _hoisted_20,
            _createTextVNode(" Your name will appear in the top donators on stream. The money will be used entirely for the development of the channel ♥ ")
          ])),
      _hoisted_21
    ])
  ]))
}
}

})